import styled from "styled-components";

export const StepOneContainer = styled.div`
  form {
    .address-container {
      margin-top: 3px;
    }

    .input-container {
      position: relative;
      height: 80px;
    }

    .input-loading .icon-container {
      position: absolute;
      right: 10%;
      top: 38%;
      transform: translate(50%, -50%);
      z-index: 10;
    }

    .input-spinner {
      width: 16px;
      height: 16px;
      border: 2px solid #ddd;
      border-top-color: #888;
      border-radius: 50%;
      animation: spin 0.6s linear infinite;
    }

    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }

    .loading {
      opacity: 0.5;
      pointer-events: none;
    }

  }

  @media (min-width: 768px) {
    form {
      min-height: 670px;

      .input-container {
        width: 47%;
      }

      .address-container {
        margin-top: 5px;
      }

      .inputs-side-by-side {
        display: flex;
        justify-content: space-between;
      }
    }
  }
`;
